// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"TyreFilter_resetButton__uek2J"};